module.exports = __webpack_public_path__ + "494cd07c/img/arrow-left-icon.785c715c.svg";